/* Own Orbit - single product-form Shop Now, no duplicate Shopify product forms. */
(function () {
  'use strict';
  var busy = false;
  function getSection(element) { return element.closest('#gen-product-information'); }
  function getForm(section) {
    return section && section.querySelector('.product-details product-form-component form[data-type="add-to-cart-form"]');
  }
  function getSizeGroup(section) {
    var group = section.querySelector('.product-details .variant-option[data-is-size-option="true"]');
    if (!group) return null;
    var picked = group.querySelector('input[type="radio"]:checked');
    var select = group.querySelector('select.variant-option__select');
    return picked || (select && select.value) ? null : group;
  }
  function showError(section, message) {
    var old = section.querySelector('.oo-shop-now__error');
    if (old) old.remove();
    var first = section.querySelector('.product-details .oo-shop-now--inline');
    if (!first) return;
    var alert = document.createElement('p');
    alert.className = 'oo-shop-now__error';
    alert.setAttribute('role', 'alert');
    alert.textContent = message;
    first.insertAdjacentElement('afterend', alert);
  }
  function updateBusy(section, state) {
    section.querySelectorAll('[data-oo-shop-now]').forEach(function (button) {
      button.setAttribute('aria-busy', state ? 'true' : 'false');
      var disabled = state || button.dataset.ooSoldOut === 'true';
      if (button.disabled !== disabled) button.disabled = disabled;
      var label = button.querySelector('[data-oo-shop-now-label]');
      if (label) label.textContent = state ? 'CONTINUING...' : 'SHOP NOW';
    });
  }
  function sync(section) {
    var form = getForm(section);
    var native = section.querySelector('.product-details product-form-component form button.add-to-cart-button');
    var soldOut = !form || !native || native.disabled;
    section.querySelectorAll('[data-oo-shop-now]').forEach(function (button) {
      var soldOutFlag = soldOut ? 'true' : 'false';
      if (button.dataset.ooSoldOut !== soldOutFlag) button.dataset.ooSoldOut = soldOutFlag;
      if (button.disabled !== (busy || soldOut)) button.disabled = busy || soldOut;
    });
  }
  document.addEventListener('click', async function (event) {
    var target = event.target.closest('[data-oo-shop-now]');
    if (!target || busy || target.disabled) return;
    var section = getSection(target);
    if (!section) return;
    var missingSize = getSizeGroup(section);
    if (missingSize) {
      missingSize.scrollIntoView({behavior: 'smooth', block: 'center'});
      var input = missingSize.querySelector('input[type="radio"], select');
      if (input) input.focus({preventScroll: true});
      return;
    }
    var form = getForm(section);
    var original = form && form.querySelector('button.add-to-cart-button');
    var variantId = form && form.querySelector('input[name="id"]');
    if (!form || !original || original.disabled || !variantId || !variantId.value) {
      showError(section, 'Please select an available size and color before checkout.');
      return;
    }
    var old = section.querySelector('.oo-shop-now__error');
    if (old) old.remove();
    busy = true;
    updateBusy(section, true);
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    base = base.replace(/\/?$/, '/');
    try {
      var response = await fetch(base + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: {Accept: 'application/json'},
        credentials: 'same-origin'
      });
      if (!response.ok) {
        var error = await response.json().catch(function () { return {}; });
        throw new Error(typeof error.description === 'string' ? error.description : 'This option is unavailable. Please check your selection.');
      }
      window.location.assign(base + 'checkout');
    } catch (err) {
      showError(section, err.message || 'Could not continue to checkout. Please try again.');
      busy = false;
      updateBusy(section, false);
      sync(section);
    }
  });
  function init() {
    document.querySelectorAll('#gen-product-information').forEach(function (section) {
      if (section.dataset.ooShopNowReady) return;
      section.dataset.ooShopNowReady = 'true';
      sync(section);
      section.addEventListener('change', function () { requestAnimationFrame(function () { sync(section); }); });
      var details = section.querySelector('.product-details');
      if (details) {
        new MutationObserver(function () { sync(section); }).observe(details, {
          subtree: true, attributes: true, attributeFilter: ['disabled', 'value'], childList: true
        });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
